export default __webpack_public_path__ + "dcda9e3ba6a1543e4a944176eacb9fec.png";